
import React from 'react';
import EvsCca from 'views/EvsCca';

const AccountGeneralPage = () => {
  return <EvsCca />;
};

export default AccountGeneralPage;
